import seedHelperFn from './seedHelperFn';
import {LIKES_MUTATION_TEMPLATE} from './templates/mutationTemplates';
import {
  mutationRequest,
  mutateCondolenceLikesSuccess,
  mutateCondolenceLikesFailure,
} from './actions';

/**
 * Posts condolence likes data to graphQL
 * @return {function} returns the function to make the fetch
 */
export const mutateCondolenceLikes = seedHelperFn(
  LIKES_MUTATION_TEMPLATE,
  'mutation',
  mutationRequest,
  mutateCondolenceLikesSuccess,
  mutateCondolenceLikesFailure
);



// WEBPACK FOOTER //
// ./src/reactModules/redux/likesHelper.js